import { useLang } from "../i18n/LanguageContext";
import { Snowflake, Flame, Wrench, Wind } from "lucide-react";

const ICONS = {
  snowflake: Snowflake,
  flame: Flame,
  wrench: Wrench,
  wind: Wind,
};

export const Services = () => {
  const { t } = useLang();

  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-heat" data-testid="services-eyebrow">
            {t.services.eyebrow}
          </span>
          <h2 className="mt-4 font-heading font-bold text-white tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="services-title">
            {t.services.title}
          </h2>
          <p className="mt-5 text-white/70 text-base sm:text-lg max-w-2xl">{t.services.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-testid="services-grid">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            const isCool = s.accent === "cool";
            const accentClass = isCool ? "card-cool text-cool" : "card-warm text-heat";
            return (
              <article
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className={`group relative rounded-3xl bg-ink-card border border-white/10 p-7 transition duration-300 hover:-translate-y-1 ${accentClass}`}
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className={`relative h-14 w-14 rounded-2xl flex items-center justify-center ${isCool ? "bg-cool/10 ring-1 ring-cool/30" : "bg-heat/10 ring-1 ring-heat/30"}`}>
                  <Icon size={26} className={isCool ? "text-cool" : "text-heat"} />
                </div>
                <h3 className="mt-6 font-heading font-bold text-xl sm:text-2xl text-white tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed">{s.desc}</p>
                <div className={`mt-7 h-px w-full ${isCool ? "bg-cool/30" : "bg-heat/30"}`} />
                <div className="mt-4 inline-flex items-center text-xs font-semibold uppercase tracking-widest text-white/55 group-hover:text-white transition">
                  {isCool ? "Cooling" : "Heating"} · DMV
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
